export * from './SendPaperplaneIcon';
export * from './SendPaperplaneIcon16Light';
export * from './SendPaperplaneIcon16Regular';
export * from './SendPaperplaneIcon16Solid';
export * from './SendPaperplaneIcon20Light';
export * from './SendPaperplaneIcon20Regular';
export * from './SendPaperplaneIcon20Solid';
export * from './SendPaperplaneIcon24Regular';
export * from './SendPaperplaneIcon24Solid';
export * from './SendPaperplaneIcon32Regular';
export * from './SendPaperplaneIcon64Regular';
